import React from 'react';
import './loader.css';

const AppLoader = ({ children, className = '', style = {} }) => {
  return (
    <div className={`app-loader ${className}`} style={style}>
      <div className='loader-spin'>
        <span className='crema-dot crema-dot-spin'>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </span>
      </div>
      {children}
    </div>
  );
};

export default AppLoader;
